import { MetaObject } from 'jsonapi-transformers';

import { MetaData } from './metadata';

export type ErrorWithETag<E> = {
  error: E;
  etag: string | null;
};

export function getErrorWithETag<T>(
  error: T,
  etag: string | null,
): ErrorWithETag<T> {
  return { error, etag };
}

export function getETagFromMetaData<T>(metadata: MetaData<T>): string | null {
  return metadata && metadata.meta && getETagFromMetaObject(metadata.meta);
}

export function getETagFromMetaObject(meta: MetaObject): string | null {
  return (meta && meta.list_etag) || null;
}

export function getETagFromError(error: any): string | null {
  return error && typeof error.etag === 'string' ? error.etag : null;
}
